import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-top-nav",
  templateUrl: "./top-nav.component.html",
  standalone: true,
  imports: [CommonModule],
  styleUrls: ["./top-nav.component.scss"],
})
export class TopNavComponent {}
